const locationTree = state => state.locationTree;

export default {
    locationTree,
};
